import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import Classe from './classe';
import ClasseDeleteModal from './classe-delete-modal';
import ClasseUpdate from './classe-update';
import ClasseDetail from './classe-details';
import CalendarEntryModal from '../calendar/calendarEntry-update';
import CalendarEntryCreateModal from '../calendar/calendarEntry-new';
import CalendarEntryDeleteModal from '../calendar/calendarEntry-deleteModal';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/new`} component={ClasseUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:id/edit`} component={ClasseUpdate} />
      <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:id/details`} component={ClasseDetail} />
      <ErrorBoundaryRoute path={`${match.url}/:ecoleid`} component={Classe} />
    </Switch>
    <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:id/delete`} component={ClasseDeleteModal} />

    <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:classeid/details/calendarEntry/:id/duplicate`} component={CalendarEntryModal} />
    <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:classeid/details/calendarEntry/:id/delete`} component={CalendarEntryDeleteModal} />
    <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:classeid/details/calendarEntry/:id`} component={CalendarEntryModal} />
    <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:id/details/calendar/new`} component={CalendarEntryCreateModal} />
  </>
);

export default Routes;
